// inquiryReducer.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api"; // make sure this handles axios or similar

// Thunk: Create an inquiry
export const createInquiry = createAsyncThunk(
  "inquiry/createInquiry",
  async (inquiryData, { rejectWithValue }) => {
    try {
      const response = await api.post("/create_inquiry", inquiryData, {
        withCredentials: true,
      });
      return response.data.newInquiry;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "Something went wrong"
      );
    }
  }
);

// Thunk: Get all inquiries
export const fetchInquiries = createAsyncThunk(
  "inquiry/fetchInquiries",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/api/fetch_inquiry");
      return response.data.inquiries;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "Something went wrong"
      );
    }
  }
);

// Initial state
const initialState = {
  inquiries: [],
  loading: false,
  error: null,
};

// Slice
const inquirySlice = createSlice({
  name: "inquiry",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create Inquiry
      .addCase(createInquiry.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createInquiry.fulfilled, (state, action) => {
        state.loading = false;
        state.inquiries.push(action.payload);
      })
      .addCase(createInquiry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch Inquiries
      .addCase(fetchInquiries.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInquiries.fulfilled, (state, action) => {
        state.loading = false;
        state.inquiries = action.payload;
      })
      .addCase(fetchInquiries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default inquirySlice.reducer;
